/**
 * Waar een groep behandelaar is: actieve formulieren en actieve soorten meldingen (hertest 29 okt.).
 *
 * Een groep verwijderen die een formulier of een soort melding opvolgt, laat die aanvragen liggen
 * zonder dat iemand ze ziet. Het venster "Groep verwijderen" noemt ze daarom vooraf. De gegevens
 * komen uit de lijsten die het beheer al heeft (`/forms`, `/floor-reports/settings/types`): de
 * module `directory` weet in de API niet wie naar haar groepen verwijst, en dat hoort zo te blijven
 * (ADR-0016) — de samenstelling gebeurt hier, op het scherm.
 */
export function groupHandlerUses(
  groupId: string,
  forms: { title: string; archived: boolean; handling: string; handlerGroupIds: string[] }[],
  types: { name: string; active: boolean; handlerGroupId: string | null }[],
): string[] {
  return [
    ...forms
      .filter(
        (form) =>
          !form.archived && form.handling === 'group' && form.handlerGroupIds.includes(groupId),
      )
      .map((form) => form.title),
    ...types
      .filter((type) => type.active && type.handlerGroupId === groupId)
      .map((type) => type.name),
  ];
}
